module.exports = __webpack_public_path__ + "img/source04_5.14149cd5.png";